import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@weezevent/nacre';

export default function WidgetPreviewButton({ widget }) {
    const { t } = useTranslation();

    const openPreview = React.useCallback(() => {
        return window.open(widget?.code_url(widget.default_language, null, true), '_blank');
    }, [widget]);

    return (
        <Button
            onClick={openPreview}
            label={
                <>
                    <Icon name="eye" /> <span>{t('ticket.common.action.preview')}</span>
                </>
            }
        />
    );
}
